import { keepPreviousData, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SortOrder } from '@/components/ui/table'
import { ResidentParkingSpot } from '@/models'

export interface GetParkingSpotsRequest {
  assignmentType?: string
  buildingId?: number
  skip?: number
  limit?: number
  search?: string
  sort?: string
  order?: SortOrder
}

export type GetParkingSpotsResponse = {
  count: number
  isInitialised: boolean
  parkings: ResidentParkingSpot[]
}

export const GET_PARKING_SPOTS_BASE_QUERY_KEY = 'useGetParkingSpots'

export const getParkingSpotsQueryKey = (data: GetParkingSpotsRequest) => [
  GET_PARKING_SPOTS_BASE_QUERY_KEY,
  data,
]

export const getParkingSpots = async (
  data: GetParkingSpotsRequest,
  signal?: AbortSignal,
): Promise<GetParkingSpotsResponse> => {
  const response = await authAPI.get<GetParkingSpotsResponse>('/parking', {
    params: data,
    signal,
  })

  return response.data
}

export const useGetParkingSpots = (data: GetParkingSpotsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    placeholderData: keepPreviousData,
    queryFn: ({ signal }) => getParkingSpots(data, signal),
    queryKey: getParkingSpotsQueryKey(data),
  })
}
